import { useSelector } from 'react-redux';

import { RootState } from '../store';
import { ICalendarState } from '../store/slices/calendarSlice';
import { IDynamicListState } from '../store/slices/dynamicListSlice';
import { IGantState } from '../store/slices/gantSlice';
import { IListItemState } from '../store/slices/listItemSlice';
import { ITableState } from '../store/slices/tableSlice';

export interface SliceStateMap {
    listItem: IListItemState;
    table: ITableState;
    gant: IGantState;
    calendar: ICalendarState;
    dynamicList: IDynamicListState<any>;
}

const useDynamicSelector = <K extends keyof SliceStateMap, T extends keyof SliceStateMap[K]>(
    sliceName: K,
    nameParam: T,
) => {
    return useSelector<RootState, SliceStateMap[K][T]>((state) => state[sliceName][nameParam]);
};

export default useDynamicSelector;
